import React, { useEffect } from 'react'
import AopsCommonModalLayout from '../modal/AopsCommonModalLayout'
// import './fastLaneModal.scss'

import { CalendarFilled } from '@ant-design/icons'
import { DatePicker, Input, message, Select, Typography } from 'antd'
import dayjs from 'dayjs'
import { useState } from 'react'
import { useRecoilState } from 'recoil'
import Swal from 'sweetalert2'
import {
  createResponseWork,
  deleteFastResponseWork,
  updateResponseWork,
} from '../../../api/aopsFastLane.api'
import { userState } from '../../../store/user'
const { Text } = Typography
// const { TextArea } = Input
const ResponseModal = ({
  open = false,
  onClose,
  title,
  responseDetail = null,
  fetchResponseList = () => {},
  onReloadInitData = () => {},
}) => {
  const [user, setUser] = useRecoilState(userState)
  const [formData, setFormData] = useState({
    title: '',
    date: null,
    hour: '09',
    minute: '30',
  })
  useEffect(() => {
    if (responseDetail) {
      const dueDateSource =
        responseDetail?.dueDate || responseDetail?.dueDateTime
      setFormData({
        title: responseDetail?.title || '',
        date: dueDateSource ? dayjs(dueDateSource) : null,
        hour: dueDateSource ? dayjs(dueDateSource).format('HH') : '09',
        minute: dueDateSource ? dayjs(dueDateSource).format('mm') : '30',
      })
    }
  }, [responseDetail])
  const hours = Array.from({ length: 24 }, (_, idx) =>
    String(idx).padStart(2, '0'),
  )
  const minutes = Array.from({ length: 6 }, (_, idx) =>
    String(idx * 10).padStart(2, '0'),
  )

  const resetForm = () => {
    setFormData({
      title: '',
      date: null,
      hour: '09',
      minute: '30',
    })
    onClose()
  }

  useEffect(() => {
    if (!open) resetForm()
  }, [open])

  const openErrorModal = (error) => {
    Swal.fire({
      customClass: { popup: 'custom-alert' },
      icon: 'error',
      title: '에러 발생',
      text: error.response.data.detail[1].description,
    })
  }

  const validateForm = () => {
    if (!formData.title) return false
    if (!formData.date) return false
    if (!formData.hour) return false
    if (!formData.minute) return false
    return true
  }

  const handleSubmit = async () => {
    if (!validateForm()) {
      message.error('모든 필드를 입력해주세요')
      return
    }
    const isEditMode = !!responseDetail
    const dueDateString =
      formData.date.format('YYYY-MM-DD') +
      ' ' +
      formData.hour +
      ':' +
      formData.minute +
      ':00'

    try {
      if (isEditMode) {
        const updatePayload = {
          workId: responseDetail?.id,
          title: formData.title,
          dueDate: dueDateString,
          isComplete: responseDetail?.isComplete,
        }
        await updateResponseWork(updatePayload)
        message.success('Response 업무가 수정되었습니다.')
        fetchResponseList()
        onReloadInitData()
      } else {
        const createPayload = {
          title: formData.title,
          dueDate: dueDateString,
          salusUserId: user.id,
        }
        await createResponseWork(createPayload)
        message.success('Response 업무가 생성되었습니다.')
        fetchResponseList()
        onReloadInitData()
      }
      resetForm()
    } catch (error) {
      console.log(error)
      openErrorModal(error)
    }
  }

  const handleDelete = async () => {
    try {
      await deleteFastResponseWork(responseDetail?.id)
      message.success('Response 업무가 삭제되었습니다.')
      resetForm()
      fetchResponseList()
      onReloadInitData()
    } catch (error) {
      console.log(error)
      openErrorModal(error)
    }
  }
  return (
    <AopsCommonModalLayout open={open} onClose={onClose} title={title}>
      <div className="form-container">
        <div className="form-wrapper">
          <div className="form-section">
            <label className="form-label">
              업무 명 <span style={{ color: 'red' }}>*</span>
            </label>
            <div style={{ width: '100%' }}>
              <Input
                placeholder="생성할 체크리스트 업무의 이름을 입력해주세요"
                value={formData.title}
                onChange={(e) => {
                  if (e.target.value.length > 50) return
                  setFormData({ ...formData, title: e.target.value })
                }}
                className="form-input"
                // readOnly={true}
              />
              <div className="example-text-group">
                <Text className="example-text">Response 업무란?</Text>
                <Text
                  className="example-text"
                  style={{
                    fontSize: '12px',
                    color: '#585F65',
                    fontWeight: '400',
                  }}
                >
                  내부가 속도를 결정하지 않고 외부와의 협업 중의 대기가 본질인
                  업무
                </Text>
              </div>
            </div>
          </div>
          <div className="form-section">
            <label className="form-label">
              완료 시간 <span style={{ color: 'red' }}>*</span>
            </label>
            <div style={{ width: '100%' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  width: '100%',
                }}
              >
                <DatePicker
                  disabledDate={(current) =>
                    current && current < dayjs().startOf('day')
                  }
                  style={{ flex: 0.4, height: '48px' }}
                  placeholder="날짜를 선택해주세요"
                  suffixIcon={<CalendarFilled />}
                  value={formData.date}
                  onChange={(date) => setFormData({ ...formData, date })}
                  // disabled={true}
                  readOnly={true}
                  format="YYYY-MM-DD"
                  // readOnly={true}
                />
                <Select
                  style={{ width: 80, height: '48px' }}
                  value={formData.hour}
                  onChange={(hour) => setFormData({ ...formData, hour })}
                  // disabled={true}
                  options={hours.map((hour) => ({ label: hour, value: hour }))}
                  popupMatchSelectWidth={false}
                  placeholder="Ex) 09"
                />
                <span>:</span>
                <Select
                  style={{ width: 80, height: '48px' }}
                  value={formData.minute}
                  onChange={(minute) => setFormData({ ...formData, minute })}
                  // disabled={true}
                  options={minutes.map((minute) => ({
                    label: minute,
                    value: minute,
                  }))}
                  popupMatchSelectWidth={false}
                  placeholder="Ex) 30"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="popup-footer">
          <button
            className="btn-cancel"
            onClick={responseDetail ? handleDelete : resetForm}
          >
            {responseDetail ? '삭제' : '취소'}
          </button>
          <button className="btn-submit" onClick={handleSubmit}>
            {responseDetail ? '수정' : '등록'}
          </button>
        </div>
      </div>
    </AopsCommonModalLayout>
  )
}

export default ResponseModal
